import classNames from 'classnames';
import InfoPopover from 'components/ui/InfoPopover/InfoPopover';
import {getDeepValue} from 'helpers/common';

import {useFormContext} from 'react-hook-form';
import ErrorFeedback from '../ErrorFeedback/ErrorFeedback';
import {IDefaultControlProps} from '../Form/Form';

import styles from './Radio.module.scss';

export interface IRadioOptions {
    label: React.ReactNode;
    value: string | number;
    description?: React.ReactNode;
    disabled?: boolean;
}

interface IRadioProps extends IDefaultControlProps {
    options: IRadioOptions[];
    horizontal?: boolean;
    defaultValue?: string | number;
}

const Radio = (props: IRadioProps) => {
    const {
        name,
        label,
        options,
        info,
        className,
        horizontal,
        disabled,
        readOnly,
        defaultValue,
        registerOptions,
        onChange,
    } = props;
    const {register, errors, setValue} = useFormContext();
    return (
        <div
            className={classNames(styles.container, className, {
                [styles.horizontal]: horizontal,
                [styles.invalid]: getDeepValue(errors, name),
            })}
        >
            <label htmlFor={name} className={styles.label}>
                {label}
                {info ? <InfoPopover content={info} /> : null}
            </label>
            {options.map(o => {
                return (
                    <>
                        <div className={styles.checkItem} key={`${o.value}`}>
                            <input
                                id={`${name}_${o.value.toString()}`}
                                name={name}
                                type="radio"
                                ref={register(registerOptions)}
                                className={classNames(styles.input, {
                                    [styles.disabled]: disabled || readOnly,
                                    [styles.invalid]: getDeepValue(
                                        errors,
                                        name,
                                    ),
                                })}
                                value={o.value}
                                disabled={disabled || readOnly || o.disabled}
                                defaultChecked={defaultValue === o.value}
                                onChange={e => {
                                    if (onChange) {
                                        onChange(e);
                                    }
                                    setValue(name, e.target.value);
                                }}
                            />
                            <label
                                htmlFor={`${name}_${o.value.toString()}`}
                                className={classNames(styles.checkItemLabel, {
                                    [styles.invalid]: getDeepValue(
                                        errors,
                                        name,
                                    ),
                                })}
                            >
                                <div className={styles.circle} />
                                {o.label}
                                {o.description ? (
                                    <div className={styles.description}>
                                        {o.description}
                                    </div>
                                ) : null}
                            </label>
                        </div>
                    </>
                );
            })}
            {getDeepValue(errors, name)?.message ? (
                <ErrorFeedback message={getDeepValue(errors, name).message} />
            ) : null}
        </div>
    );
};

export default Radio;
